// extracted by mini-css-extract-plugin
export default {"noAnswerTitle":"NoAnswer_noAnswerTitle__CQe+l","noAnswerByline":"NoAnswer_noAnswerByline__+tlZO"};